import { Injectable} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { AppAuthService } from './app-auth.service';

@Injectable({
    providedIn: 'root'
})
export class StartUpService {

    constructor(private _appAuthService: AppAuthService, private _auth: AuthService) { }

    async init() {
        const isAuthenticated = await firstValueFrom(this._auth.isAuthenticated$);

        if (isAuthenticated) await this._appAuthService._initialize();
    }
}
